export default {"src":"/_next/static/media/check.25ea0553.svg","height":72,"width":72};